module.exports = __webpack_public_path__ + "img/9788958287124.28740318.jpg";